import { ServerError } from "@flaminem/utils";

import { ModalError } from "src/components/Modal";
import { ErrorCode } from "src/graphql/utils/errorBuilder";

export const mapToModalError = <TError extends ServerError<ErrorCode> | null | undefined>(
  error: TError
): TError extends null | undefined ? ModalError | undefined : ModalError => {
  return (
    error
      ? ({
          title: error.title,
          subtitle: error.message,
        } satisfies ModalError)
      : undefined
  ) as TError extends null | undefined ? ModalError | undefined : ModalError;
};
